var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndefiniteCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24992 0.19165V2.02498H12.7499V0.19165H14.5833V2.02498H18.2499C18.493 2.02498 18.7262 2.12156 18.8981 2.29347C19.07 2.46538 19.1666 2.69854 19.1666 2.94165V17.6083C19.1666 17.8514 19.07 18.0846 18.8981 18.2565C18.7262 18.4284 18.493 18.525 18.2499 18.525H1.74992C1.5068 18.525 1.27365 18.4284 1.10174 18.2565C0.929829 18.0846 0.833252 17.8514 0.833252 17.6083V2.94165C0.833252 2.69854 0.929829 2.46538 1.10174 2.29347C1.27365 2.12156 1.5068 2.02498 1.74992 2.02498H5.41658V0.19165H7.24992ZM17.3333 8.44165H2.66659V16.6917H17.3333V8.44165ZM12.7829 9.48298L14.0791 10.7792L9.54158 15.3167L6.30025 12.0753L7.59825 10.7792L9.5425 12.7243L12.7829 9.48298ZM5.41658 3.85832H2.66659V6.60832H17.3333V3.85832H14.5833V4.77498H12.7499V3.85832H7.24992V4.77498H5.41658V3.85832Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndefiniteCalendarIcon);
export default __webpack_public_path__ + "static/media/indefinite-calendar-icon.67ba52956c0c01b44d2ce078c58383d9.svg";
export { ForwardRef as ReactComponent };